
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// This hook tracks page views in Google Analytics
const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if gtag exists (Google Analytics is loaded)
    if (typeof window.gtag !== 'undefined') {
      // Send pageview with the page's path and title
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
      
      console.log('Page view tracked:', location.pathname + location.search);
    }
  }, [location]);
};

export default usePageTracking;
